const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const usdInt = new Intl.NumberFormat('en-US', {
  style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0,
});
const sharesFmt = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0, maximumFractionDigits: 3,
});

export const formatCurrency = (value: number): string => usd.format(value);
export const formatCurrencyInt = (value: number): string => usdInt.format(value);
export const formatSignedCurrency = (value: number): string =>
  `${value > 0 ? '+' : ''}${usd.format(value)}`;
export const formatShares = (value: number): string => sharesFmt.format(value);

export const formatPercent = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return 'N/A';
  return `${value >= 0 ? '+' : ''}${value.toFixed(2)}%`;
};

export const formatShortDate = (value: string): string => {
  const date = new Date(value);
  if (isNaN(date.getTime())) return 'N/A';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const formatCompactCurrency = (value: number): string => {
  if (Math.abs(value) >= 1e12) return `$${(value / 1e12).toFixed(1)}T`;
  if (Math.abs(value) >= 1e9) return `$${(value / 1e9).toFixed(1)}B`;
  if (Math.abs(value) >= 1000000) return `$${(value / 1000000).toFixed(1)}M`;
  if (Math.abs(value) >= 1000) return `$${(value / 1000).toFixed(1)}K`;
  return `$${value.toFixed(0)}`;
};

export const formatCompactNumber = (value: number): string => {
  if (Math.abs(value) >= 1e9) return `${(value / 1e9).toFixed(1)}B`;
  if (Math.abs(value) >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
  if (Math.abs(value) >= 1000) return `${(value / 1000).toFixed(1)}K`;
  return `${value}`;
};

export const formatDateTime = (value: string | null | undefined): string => {
  if (!value) return 'N/A';
  const date = new Date(value);
  if (isNaN(date.getTime())) return 'N/A';
  const month = date.toLocaleString('en-US', { month: 'short' });
  return `${month} ${date.getDate()}, ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};
